module.exports = __webpack_public_path__ + "static/media/trioLastResultsPopUp.32a0f4c3.png";